const firebaseConfig = {
    apiKey: "AIzaSyB4hDYhHiz2qu_HAZL7epAZcPXxUDnkqf8",
    authDomain: "travel-guru-website-ace48.firebaseapp.com",
    databaseURL: "https://travel-guru-website-ace48.firebaseio.com",
    projectId: "travel-guru-website-ace48",
    storageBucket: "travel-guru-website-ace48.appspot.com",
    messagingSenderId: "427812804170",
    appId: "1:427812804170:web:7e72a899f9fe2a9109b8b3"
  };
  export default firebaseConfig;